// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"231":"dc7b2f50","256":"a4e0976b"}[chunkId] + ".css";
};